import { Box, Stack } from "@mui/material";
import { isEmpty } from "lodash-es";

import VehicleDamageLink from "@/common/components/Entity/VehicleDamage/VehicleDamageLink";
import FileListView from "@/common/components/Files/FileListView";
import FieldValue from "@/common/components/Form/Display/FieldValue";
import { ATTACHMENTS_COMMON_ITEM_SIZES } from "@/common/constants/common";
import { FileItem } from "@/common/fileItem";
import { GenericDamage } from "@/common/ts/visualModel";

import { VisualModelViewerOfGenericDamage } from "./VisualModelViewerOfGenericDamage";

export interface GenericDamageViewProps<TDamage extends GenericDamage = GenericDamage> {
  damage: TDamage;
}

export function GenericDamageView<TDamage extends GenericDamage = GenericDamage>({
  damage,
}: GenericDamageViewProps<TDamage>) {
  return (
    <Box>
      <Stack direction='column' spacing={1}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xxs: "1fr",
              lg: "2fr 2fr",
            },
            columnGap: 2,
            rowGap: 2,
          }}
        >
          <Stack spacing={1}>
            {/* {damage.localNumber && <FieldValue label='Local number'>{damage.localNumber}</FieldValue>} */}
            <FieldValue label='Part type' isEmpty={!damage.partType && !damage.partTypeRef}>
              {damage.partType?.name || damage.partTypeRef?.name}
            </FieldValue>

            <FieldValue label='Damage type' isEmpty={!damage.damageType && !damage.damageTypeRef}>
              {damage.damageType?.name || damage.damageTypeRef?.name}
            </FieldValue>

            <FieldValue label='Area' isEmpty={!damage.area}>
              {damage.area}
            </FieldValue>

            <FieldValue label='Projection' isEmpty={!damage.projection}>
              {damage.projection}
            </FieldValue>

            {(damage.vehicleDamageId || damage.vehicleDamage?.id) && (
              <FieldValue
                label='Damage'
                isEmpty={!damage.vehicleDamageId && !damage.vehicleDamage?.id}
              >
                <VehicleDamageLink
                  vehicleId={damage.vehicleDamage?.vehicle?.id}
                  entityId={damage.vehicleDamageId || damage.vehicleDamage?.id}
                  entity={damage.vehicleDamage}
                />
              </FieldValue>
            )}

            {damage.notes && (
              <FieldValue label='Notes' isEmpty={!damage.notes}>
                {damage.notes}
              </FieldValue>
            )}

            {!isEmpty(damage.attachments) && (
              <Box sx={{ mt: 2 }}>
                <FileListView
                  files={FileItem.createManyFrom(damage.attachments)}
                  maxVisibleFiles={10}
                  itemWidth={ATTACHMENTS_COMMON_ITEM_SIZES.WIDTH}
                  itemHeight={ATTACHMENTS_COMMON_ITEM_SIZES.HEIGHT}
                />
              </Box>
            )}
          </Stack>

          {/* Visual model and damage point */}
          <Stack spacing={1} sx={{ overflow: "hidden" }}>
            <VisualModelViewerOfGenericDamage damage={damage} />
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
}
